$(document).on('mouseover', function(e){
    e.stopPropagation();

    if($('body').hasClass('collapsed-menu') && $('#btnLeftMenu').is(':visible')) {
        var targ = $(e.target).closest('.sideLeft').length;
        if(targ) {
            $('body').addClass('expand-menu');

            // show current shown sub menu that was hidden from collapsed
            $('.showSub + .menuSub').addClass('d-block');

            var menuText = $('.menuItemLabel,.menuItemArrow');
            menuText.removeClass('lhide');
            menuText.removeClass('opacity0I-l');

        } else {
            $('body').removeClass('expand-menu');
            $('.showSub + .menuSub').removeClass('d-block');

            var menuText = $('.menuItemLabel,.menuItemArrow');
            menuText.addClass('opacity0I-l');
            menuText.addClass('lhide');
        }
    }
});

$(document).on('click', '#btnLeftMenu', function(){
    var menuText = $('.menuItemLabel,.menuItemArrow');

    if($('body').hasClass('collapsed-menu')) {
        $('body').removeClass('collapsed-menu');
        $('.showSub + .menuSub').addClass('d-block');

        $('.sideLeft').one('transitionend', function(e) {
            menuText.removeClass('opacity0I-l');
            menuText.removeClass('lhide');
        });

    } else {
        $('body').addClass('collapsed-menu');

        $('.showSub + .menuSub').removeClass('d-block');
        $('.showSub + .menuSub').css('background-color', 'transparent');
        $('.showSub + .menuSub').css('color', 'white');

        menuText.addClass('opacity0I-l');
        $('.sideLeft').one('transitionend', function(e) {
            menuText.addClass('lhide');
        });
    }
    return false;
});

$(document).on('change', 'input[name="show-retail-prices"]', function(){
    axios.post('/api/portal/toggle-retail-prices', {'checked': $(this).is(":checked") ? 1 : 0}).then(response => {
        location.reload();
    });
});

// Handle filter collapse button
$(document).on('click', '.toggleFilter', function(e) {
    e.preventDefault();
    let $this = $(this);
    $this.closest('.toggleGroup').find('.toggleDiv').toggle();
});
